import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { get, getOr } from 'lodash/fp';
import Sticky from 'react-stickynode';
import EstimateHeader from './EstimateHeaderConnector';
import EstimateSummary from './EstimateSummaryConnector';
import InstallationSummary from './InstallationSummary';
import { ContainerCards } from './ContainerCards';
import TopLevelExpander from './TopLevelExpanderConnector';
import useMedia from '../../hooks/useMedia';
import { breakpointsDesktopFirst } from '../../themes/breakpoints';
import CopyStylesModal from '../CopyStylesModal';
import MandiEditAttributesModal from '../MandiEditAttributesModal';
import ConfirmDeleteAttributeModal from '../modals/ConfirmDeleteAttributeModal';

const EstimateCard = ({ design }) => {
  useEffect(() => {
    const summary = document.getElementsByClassName('estimateSummary')[0];
    if (summary && summary.clientHeight) {
      const summaryHeight = `${summary.clientHeight}px`;
      const inner = document.getElementsByClassName('sticky-inner-wrapper')[0];
      if (inner) {
        inner.style.minHeight = summaryHeight;
      }
    }
  });
  const isMobile = useMedia(breakpointsDesktopFirst.tablet);

  const designId = get('designId', design);

  if (!design) {
    return null;
  }

  const SummaryElement = getOr(false, 'attributes.isMandi', design) ? InstallationSummary : EstimateSummary;

  return (
    <div className="estimateCard">
      <CopyStylesModal designId={designId} />
      <MandiEditAttributesModal designId={designId} />
      <ConfirmDeleteAttributeModal />
      <EstimateHeader designId={designId} />
      <TopLevelExpander />
      <div className="columns">
        {isMobile
        ? <SummaryElement className="tablet-mobile-only" designId={designId} />
        : (
          <Sticky bottomBoundary="#estimateBuilderRoot">
            <SummaryElement className="desktop-only" designId={designId} />
          </Sticky>
        )
        }
        <ContainerCards containerIds={design.containers} />
      </div>
    </div>
  );
};

EstimateCard.propTypes = {
  design: PropTypes.shape({
    designId: PropTypes.string.isRequired,
  }),
};
EstimateCard.defaultProps = {
  design: null,
};

export default EstimateCard;
